import React from "react";
import classNames from "classnames";
import { Card } from "@netapp/bxp-design-system-react";
import typography from "@netapp/bxp-design-system-react/styles/typography.module.scss";
import {CloseMonochromeIconsIcon as Close} from "@netapp/bxp-design-system-react/icons/monochrome";
import {ReactComponent as PurpleMan} from "./purple-man.svg";
import styles from "./WeakConnectorBanner.module.scss"
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { currentConnector as i18nNamespace } from "../../../i18n/namespace";

const WeakConnectorBanner = React.memo(() => {
    const dispatch = useDispatch();
    const { t } = useTranslation(i18nNamespace);

    return <Card className={styles.base}>
        <div className={styles.purple}>
            <PurpleMan/>
            <p className={classNames(typography.b, typography.body15)}>{t("new_services_are_now_available")}</p>
        </div>
        <div className={styles.text}>
            <button onClick={() => {
                dispatch({
                    type: "CURRENT-CONNECTOR:OPEN-WEAK-CONNECTOR-DIALOG",
                    track: "from-banner"
                })
            }}><p className={typography.b}>{t("click_here_to_improve_your_blue_xp_experience")}</p></button>
            <button className={styles.close} onClick={() => {
                dispatch({
                    type: "CURRENT-CONNECTOR:CLOSE-WEAK-CONNECTOR-BANNER"
                })
            }}>
                <Close/>
            </button>
        </div>
    </Card>
});

export default WeakConnectorBanner;